import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Card, CardBody, Col, Progress } from "reactstrap";

const ProgressDataBudget = props => {

  const getProgressColor = (val) => {
    if (val < 75) {
      return 'success'
    } else {
      return "secondary";
    }
  }

  const getWidgetPercent = (payment_sum, total_budget) => {
    return payment_sum / total_budget * 100
  }
  
  return (
    <ProgressDataBudgetStyled>
      {props.widgetData !== null && props.widgetData.length > 0 && (
        <Col xl={12}>
          <Card>
            <CardBody>
              <div className="mt-1 mb-2 d-flex justify-content-between">
                <div>
                  <h5 className="font-size-12 mb-0 fade-in-custom-animate">
                    Total budget: {props.widgetData[0].total_budget} {props.nonCahortDate?.currency || 'USD'}
                  </h5>
                </div>
                <div>
                  <h5 className="font-size-12 mb-0 fade-in-custom-animate">
                    {getWidgetPercent(props.widgetData[0].payment_sum, props.widgetData[0].total_budget).toFixed(2)}%
                  </h5>
                </div>
              </div>
              <div className="mb-1">
                <Progress
                  value={props.widgetData[0].payment_sum}
                  max={props.widgetData[0].total_budget}
                  color={getProgressColor(getWidgetPercent(props.widgetData[0].payment_sum, props.widgetData[0].total_budget).toFixed(2))}
                  className="progress-lg"
                ></Progress>
              </div>
            </CardBody>
          </Card>

        </Col>
      )}
    </ProgressDataBudgetStyled>
  );
};

const ProgressDataBudgetStyled = styled.div`

`;

ProgressDataBudget.propTypes = {
  widgetData: PropTypes.any,
  nonCahortDate: PropTypes.any,
};

export default ProgressDataBudget;
